<template>
  <div>
    <div class="Fuell-Toolbar d-flex justify-content-between">
      <div class="d-flex toolbar-column multiselect-section-selector">
        <span class="multiselect-section-selector-label">{{ $t('export_exportation_flow_using') }}</span>
        <multiselect
          :value="exportationFlowSelected"
          :label="'name'"
          track-by="id"
          :placeholder="$t('export_exportation_flow_using_placeholder')"
          open-direction="bottom"
          :options="exportationFlows"
          :multiple="false"
          :searchable="false"
          :allowEmpty="false"
          :selectLabel="''"
          :selectedLabel="''"
          :deselectLabel="''"
          @select="setExportationFlow($event)"
        >
          <template slot="afterList">
            <li class="Fuell-New-Export--container">
              <span @click="showCreateExportationFlow(true)">
                {{ $t('export_flow_create_export_flow') }}
              </span>
            </li>
          </template>

        </multiselect>
        <span
          class="multiselect-section-selector-link clickable"
          @click="showCreateExportationFlow(false)"
        >{{$t('export_flow_modify')}}</span>
      </div>
      <div class="group-links">
        <router-link
          to="/export/exported"
          class="Fuell-Tabs--link"
        >
          {{$t('export_exportation_flow_exported')}}
          <img
            alt="icon-arrow-right"
            :src="require('@/assets/img/icons/icon-arrow-right-double.svg')"
          />
        </router-link>
      </div>
    </div>

    <ul class="Fuell-Tabs">
      <li
        v-for="tab in tabs"
        :key="tab.id"
        class="Fuell-Tabs--tab"
      >
        <router-link
          :to="tab.to"
          class="Fuell-Tabs--link"
          active-class="active"
          @click.native="changeTab(tab.type)"
        >
          {{$t(`export_exportation_flow_tabs_${tab.name}`)}}
        </router-link>
      </li>
    </ul>
    <div class="Fuell-Toolbar w-100">
      <div class="d-flex justify-content-between toolbar-column w-100">
        <div class="d-flex flex-row">
        <entity-search-input @search="fetchTransactions"></entity-search-input>
        <button
          @click="showFilterModal"
          class="Fuell-ToolbarButton"
        >
          <span class="Fuell-ToolbarButton--icon">
            <img
              :src="require('@/assets/img/icons/icon-filter.svg')"
              alt="filter"
            />
          </span>
          <span class="Fuell-ToolbarButton--label">
            {{ $t('FILTERS') }}
          </span>
          <span
            class="Fuell-ToolbarButton--badge"
            v-if="filtersAmount"
            aria-hidden="true"
          >
            {{ filtersAmount }}
          </span>
          <span
            class="Fuell-ToolbarButton remove-container"
            v-if="filtersAmount > 0"
            @click.prevent.stop="resetFilters"
          >
            <inline-svg
              style="height:10px;"
              :src="require('@/assets/img/icons/close-menu.svg')"
              alt="remove-filters"
            />
          </span>
        </button>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <table-column-selector :columns="tableExportColumns" midContainer @toggleColumn="toggleExportTableColumnVisibility($event)"/>
        </div>
      </div>
    </div>
    <transactions-table
      :tableName="tableName"
      :columns="tableExportColumns"
      :showSelect="true"
      isExportTable
      @setBulkAction="setBulkAction"
    ></transactions-table>
    <transactions-filter-modal
      v-if="showFilterModalFlag"
      :open.sync="showFilterModalFlag"
      :expenses="expenses"
      @resetTransactionsFilters="fetchTransactions($event)"
      @reviewStatusFilterSelected="incrementReviewStatusFilterCounter"
    >
    </transactions-filter-modal>
    <create-exportation-flow-modal
      v-if="showCreateExportationFlowFlag"
      :open.sync="showCreateExportationFlowFlag"
      :exportationFlowId="flowId"
      @fetchTransactions="fetchTransactions"
    ></create-exportation-flow-modal>
    <transition name="pop">
      <multiple-actions-banner
        v-if="selectedTransactions.length > 0"
        @closeBar="clearAll"
      >
        <template v-slot:selectedItems>
          <template>
            <i18n
              tag="span"
              class="Fuell-Text"
              path="transactions_total_transactions_selected"
            >
              <template v-slot:selectedTransactions>
                <span class="text-primary">{{!selectedTransactionsBulkAction ? selectedTransactions.length : transactionsTotalItems}}</span>
              </template>
              <template v-slot:transactionType>
                {{ isInExpenseSections ? $tc('transactions_table_total_count_and_amount_expense_type', !selectedTransactionsBulkAction ? selectedTransactions.length : transactionsTotalItems): $tc('transactions_table_total_count_and_amount_transaction_type', !selectedTransactionsBulkAction ? selectedTransactions.length : transactionsTotalItems)}}
              </template>
            </i18n>
          </template>
        </template>
        <template v-slot:actions>
          <button
            class="Fuell-Button Fuell-Button--small blue"
            @click="exportTransactions()"
          >
            <span class="Fuell-Button--label">
              {{$t('export_flow_export')}}
            </span>
          </button>
        </template>
      </multiple-actions-banner>
    </transition>
  </div>
</template>

<script>
import transactionsApi from '@/modules/transactions/_api'
import _transactionsMultipleSelectHandlerMixin from '@/modules/transactions/_mixins/_transactionMultipleSelectHandlerMixin'
import _exportMixins from '../../_mixins/_exportMixins'
import EntitySearchInput from '@/components/Commons/Search/EntitySearchInput'
import InlineSvg from 'vue-inline-svg'
import TableColumnSelector from '../../../../components/Commons/TableColumnSelector.vue'
const MultipleActionsBanner = () => import('@/components/Commons/MultipleActionsBanner')

export default {
  name: 'ListExportsIndex',
  mixins: [
    _transactionsMultipleSelectHandlerMixin,
    _exportMixins
  ],
  components: {
    EntitySearchInput,
    InlineSvg,
    MultipleActionsBanner,
    TableColumnSelector
  },
  computed: {
    columnsExport () {
      let defaultDate = false
      let defaultDateIndex = 0
      this.columns.forEach((item, index) => {
        if (item.isDate && item.key !== this.exportationFlow.filters.filter.referenceDate) {
          defaultDate = true
          item.visible = false
        } else if (item.isDate && item.key === this.exportationFlow.filters.filter.referenceDate) {
          defaultDate = true
          item.visible = true
        }
        if (item.key === 'date') {
          defaultDateIndex = index
        }
      })
      if (!defaultDate) {
        this.$set(this.columns[defaultDateIndex], 'visible', true)
      }
      return this.columns
    },
    tableExportColumns () {
      return this.$store.getters['TransactionsStore/tableExportColumns']
    },
    expenses () {
      return this.$store.getters['TransactionsStore/expenses']
    },
    exportHistory () {
      return this.$store.getters['ExportStore/exportHistory']
    },
    selectedTransactionsBulkAction () {
      return this.$store.getters['TransactionsStore/selectedTransactionsBulkAction']
    }
  },
  methods: {
    setBulkAction (value) {
      this.$store.dispatch('TransactionsStore/setSelectedTransactionsBulkAction', value)
    },
    changeTab (tab) {
      this.tab = tab
      this.fetchTransactions()
    },
    toggleExportTableColumnVisibility (column) {
      this.$store.dispatch('TransactionsStore/toggleExportTableColumnVisibility', column)
    },
    async exportTransactions () {
      const exportHistory = {
        exportSetting: { id: this.exportationFlowSelected.id },
        filters: { filter: this.filters }
      }
      let referenceDate = exportHistory.filters.filter.referenceDate
      if (referenceDate && exportHistory.filters.filter[`${referenceDate}[after]`] && this.$moment.utc(exportHistory.filters.filter[`${referenceDate}[after]`]).isValid()) {
        exportHistory.filters.filter[`${referenceDate}[after]`] = this.$moment.utc(exportHistory.filters.filter[`${referenceDate}[after]`]).startOf('day').format()
      }
      if (referenceDate && exportHistory.filters.filter[`${referenceDate}[before]`] && this.$moment.utc(exportHistory.filters.filter[`${referenceDate}[before]`]).isValid()) {
        exportHistory.filters.filter[`${referenceDate}[before]`] = this.$moment.utc(exportHistory.filters.filter[`${referenceDate}[before]`]).endOf('day').format()
      }

      if (!this.selectedTransactionsBulkAction) {
        exportHistory.transactions = this.selectedTransactions.map(item => item.id)
      }
      await this.$store.dispatch('ExportStore/createExportHistory', exportHistory).then(async () => {
        await transactionsApi.getExportBackground({ ...this.filters, exportTypeCode: 'CUSTOM', exportSettingHistoryId: this.$store.getters['ExportStore/exportHistory'].id })
      })
      this.$router.push('/export/exported')
    }
  },
  created () {
    this.showTabs()
    this.fetchTransactions()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.multiselect-section-selector {
  align-items: center;
  flex: 1;
  .multiselect-section-selector-label {
    font-size: 15px;
    color: var(--text-heading);
  }
  .multiselect {
    max-width: 240px;
    margin: 0 16px;
  }
  .multiselect-section-selector-link {
    font-size: 15px;
    color: var(--blue);
  }
}
.group-links {
  a {
    display: flex;
    align-items: center;
    line-height: 16px;
    height: 16px;
    img {
      margin-top: 3px;
      margin-left: 5px;
      height: 8px;
    }
  }
  @media screen and (max-width: 576px) {
    margin-top: 15px;
  }
}
.Fuell-New-Export--container {
  position: sticky;
  bottom: 0;
  margin: 0;
  height: 45px;
  background-color: var(--white);
  span {
    color: var(--text-link);
    display: block;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    cursor: pointer;
    white-space: nowrap;
  }
}

@media screen and (max-width: 576px) {
  .Fuell-Toolbar {
    flex-direction: column;
    width: 100%;
  }
  .toolbar-column {
    display: flex;
    flex-direction: column;
    width: 100%;
    > * {
      margin: 10px 0px;
    }
  }
  .multiselect-section-selector-label {
    width: 100%;
    display: flex;
    margin: 0px 0px 10px 25px;
    justify-content: center;
  }
  .multiselect-section-selector .multiselect {
    max-width: 100%;
  }
  .Fuell-ToolbarSearch {
    width: 100%;
  }
}
</style>
